export const getLoanIdAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_LOAN_ID":
      return action.data;

    default:
      return state;
  }
};
